if (!customElements.get('size-guide-bra')) {
    class SizeGuideBra extends window.SizeGuideBase {
        get storageKey () { return 'woman'; }
        get guideType () { return 'bra'; }

        updateFormData (element) {
            const field = element?.dataset?.field;
            const value = element?.value;
            this.formData[field] = value;

            if (this.formData.bra !== undefined && this.formData.cup !== undefined && this.formData.height !== undefined) {
                this.computeBraRecommendation();
            }
        }

        computeBraRecommendation () {
            this.formData.braRecommendation = this.data.find(
                entry =>
                    Number(entry.bra) === Number(this.formData.bra) &&
                    Number(entry.cup) === Number(this.formData.cup)
            );

            this._handleRecommendation(this.formData.braRecommendation?.size);
        }
    }

    customElements.define('size-guide-bra', SizeGuideBra);
}
